import gql from 'graphql-tag'
export default gql`
  query SearchVariables {
    SearchVariables @client {
      limit
      offset
      value
      filters @client {
        value
        op
        valueKey
      }
      itemType
    }
  }
`
